module.exports = __webpack_public_path__ + "static/media/cementary.2f229c1d.svg";